export enum BmarkEventSubjectType {
  FIXING,
  ORDER_DATA,
}

export namespace BmarkEventSubjectType {
  let elements = [BmarkEventSubjectType.FIXING, BmarkEventSubjectType.ORDER_DATA];
  let alias = "com.bcdfx.model.BmarkSubjectType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
